export function round(val) {
  return parseFloat(val)
    .toFixed(2)
    .replace(/\.0+$/, '');
}
export function roundTo2(val) {
  const m = Number((Math.abs(val) * 100).toPrecision(15));
  return (Math.round(m) / 100) * Math.sign(val);
}

export function roundTo2String(val) {
  return round(val);
}

export const removeLeadingZeros = str => {
  // Regex to remove leading
  // zeros from a string
  const regex = new RegExp('^0+(?!$)', 'g');

  // Replaces the matched
  // value with given string
  return str.toString().replaceAll(regex, '');
};

export const getFloatingFieldValue = (val, old) => {
  if (/^\d+(\.\d{0,2})?$/.test(val)) {
    const value = removeLeadingZeros(val);
    return value;
  }
  if (val === '') {
    return '0';
  }
  return old;
};

export const roundOff = (floatValue, roundType) =>
  /* eslint-disable-next-line */
  roundType === 'up'
    ? Math.ceil(floatValue)
    : roundType === 'down'
      ? Math.floor(floatValue)
      : floatValue;
